import { useMemo } from 'react';
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { CHART_COLORS, formatChartTooltipValue } from '../../chartUtils';
import { useYearlyRegistrationTrendQuery } from '../../hooks/useDashboardAnalytics';
import { ChartCard } from './ChartCard';

export function YearlyRegistrationTrendChart() {
  const { data, isLoading, errorMessage } = useYearlyRegistrationTrendQuery();

  const chartData = useMemo(
    () => (data?.items ?? []).map((item) => ({ year: String(item.year), total: item.total })),
    [data]
  );

  return (
    <ChartCard
      title="Yearly Registration Trend"
      subtitle="Total new nursery registrations per year — national"
      loading={isLoading}
      error={errorMessage}
    >
      {chartData.length > 0 ? (
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartData} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="year" />
            <YAxis />
            <Tooltip formatter={(value) => formatChartTooltipValue(value)} />
            <Line
              type="monotone"
              dataKey="total"
              stroke={CHART_COLORS.forestGreen}
              strokeWidth={2}
              dot={{ r: 4, fill: CHART_COLORS.forestGreen }}
              activeDot={{ r: 6 }}
            />
          </LineChart>
        </ResponsiveContainer>
      ) : null}
    </ChartCard>
  );
}
